import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {Country} from '../../back-office/Models/Country';
import {map, catchError} from 'rxjs/operators';

/** Language list response */
export interface CountryListResponse {
  total: number;
  count: number;
  per_page: number;
  data: Country[];
}

@Injectable()
export class CountryService {
  /**
   * @param {Helper} helper
   * @param {HttpClient} http
   */
  constructor(private helper: Helper, private http: HttpClient) {
  }

  /**
   * List Country
   *
   * @returns {Observable<CountryListResponse>}
   * @param {HttpParams} params
   */
  list(
    params = new HttpParams,
  ): Observable<CountryListResponse> {
    const url = `${environment.apiUrl}/backoffice/countries`;
    return this.http.get<CountryListResponse>(
      url,
      {params: params}
    );
  }

  /**
   * List Country
   *
   * @returns {Observable<CountryListResponse>}
   * @param {HttpParams} params
   */
  getCountriesWithVats(
    params = new HttpParams,
  ): Observable<CountryListResponse> {
    const url = `${environment.apiUrl}/backoffice/countries/get-countries-with-vats`;
    return this.http.get<CountryListResponse>(
      url,
      {params: params}
    );
  }

  /**
   * Manage Country
   * @param country
   * @param isEdit
   * @param id
   */
  public manageCountry(country, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/countries/' + id, country)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/countries/ ', country)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  /**
   * Get a country by it's id.
   */
  getCountryById(id) {
    return this.http.get<Country>(
      `${environment.apiUrl}/backoffice/countries/` + id
    );
  }

  /**
   * List DateFormats
   */
  public listDateFormats() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/countries/date-formats')
      .pipe(
        map((res) => Object.keys(res.dateFormats).map(function (formatIndex) {
            return res.dateFormats[formatIndex];
          })),
        catchError(res => this.helper.catchError(res))
      );
  }

  /**
   * List DateFormats
   */
  public listCurrencyFormats() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/countries/currency-formats')
      .pipe(
        map((res) => Object.keys(res.currencyFormats).map(function (formatIndex) {
            return res.currencyFormats[formatIndex];
          })),
        catchError(res => this.helper.catchError(res))
      );
  }
}
